import { PlayerSizesTypes } from '../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import { removeHighlights } from '../styles';

interface StylesObject {
  closeIconStyle: { [key: string]: any };
}

const closeIcon = {
  position: 'absolute',
  ...removeHighlights,
  color: SITE_VARIABLES.COLORS.WHITE,
  cursor: 'pointer',
  top: '6px',
  right: '0',
  pointerEvents: 'auto',
  small: {
    height: '16px',
    width: '16px',
    minWidth: '16px',
    marginRight: '4px',
  },
  medium: {
    height: '20px',
    width: '20px',
    minWidth: '20px',
    marginRight: '8px',
  },
  large: {
    height: '16px',
    width: '16px',
    minWidth: '16px',
    marginRight: '8px',
  },
  extraLarge: {
    height: '20px',
    width: '20px',
    minWidth: '20px',
    marginRight: '16px',
  },
  hide: {
    display: 'none',
  },
};

export const getCloseButtonStyleObject = (playerSize: PlayerSizesTypes, showCloseIcon: boolean): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return ({
    closeIconStyle: [
      closeIcon,
      smallSize && closeIcon.small,
      mediumSize && closeIcon.medium,
      largeSize && closeIcon.large,
      extraLargeSize && closeIcon.extraLarge,
      !showCloseIcon && closeIcon.hide,
    ],
  });
};
